import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { UserProvider } from './context/UserContext';
import { WishlistProvider } from './context/WishlistContext';
import { NotificationsProvider } from './context/NotificationsContext';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { CookieBanner } from './components/CookieBanner';
import { NotificationToast } from './components/ui/NotificationToast';
import { ScrollToTop } from './components/ScrollToTop';
import { HomePage } from './pages/HomePage';
import { ProductsPage } from './pages/ProductsPage';
import { ProductDetailPage } from './pages/ProductDetailPage';
import { CartPage } from './pages/CartPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { SustainabilityPage } from './pages/SustainabilityPage';
import { BlogPage } from './pages/BlogPage';
import { BlogDetailPage } from './pages/BlogDetailPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsPage } from './pages/TermsPage';
import { CookiePolicyPage } from './pages/CookiePolicyPage';
import { AccountPage } from './pages/AccountPage';
import { FavoritesPage } from './pages/FavoritesPage';
import { ShippingPage } from './pages/ShippingPage';
import { FAQPage } from './pages/FAQPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <NotificationsProvider data-id="element-2">
        <UserProvider data-id="element-3">
          <WishlistProvider data-id="element-4">
            <CartProvider data-id="element-5">
              <div className="min-h-screen flex flex-col bg-gray-50 font-sans" data-id="element-6">
                <Header data-id="element-7" />
                <NotificationToast data-id="element-8" />
                {/* Adjusted padding: Mobile 72px, Desktop 36px (topbar) + 80px (header) = ~116px */}
                <div className="flex-1 pt-[72px] sm:pt-[116px] flex flex-col" data-id="element-9">
                  <Routes data-id="element-10">
                    <Route path="/" element={<HomePage data-id="element-12" />} data-id="element-11" />
                    <Route path="/productos" element={<ProductsPage data-id="element-14" />} data-id="element-13" />
                    <Route path="/productos/:id" element={<ProductDetailPage data-id="element-16" />} data-id="element-15" />
                    <Route path="/carrito" element={<CartPage data-id="element-18" />} data-id="element-17" />
                    <Route path="/checkout" element={<CheckoutPage data-id="element-20" />} data-id="element-19" />
                    <Route path="/sostenibilidad" element={<SustainabilityPage data-id="element-22" />} data-id="element-21" />
                    <Route path="/blog" element={<BlogPage data-id="element-24" />} data-id="element-23" />
                    <Route path="/blog/:id" element={<BlogDetailPage data-id="element-26" />} data-id="element-25" />
                    <Route path="/nosotros" element={<AboutPage data-id="element-28" />} data-id="element-27" />
                    <Route path="/contacto" element={<ContactPage data-id="element-30" />} data-id="element-29" />
                    <Route path="/envios" element={<ShippingPage data-id="element-32" />} data-id="element-31" />
                    <Route path="/faq" element={<FAQPage data-id="element-34" />} data-id="element-33" />

                    {/* Account Routes - Nested Routing */}
                    <Route path="/cuenta/*" element={<AccountPage data-id="element-36" />} data-id="element-35" />
                    <Route path="/favoritos" element={<FavoritesPage data-id="element-38" />} data-id="element-37" />

                    {/* Legal Routes */}
                    <Route path="/privacidad" element={<PrivacyPolicyPage data-id="element-40" />} data-id="element-39" />
                    <Route path="/terminos" element={<TermsPage data-id="element-42" />} data-id="element-41" />
                    <Route path="/cookies" element={<CookiePolicyPage data-id="element-44" />} data-id="element-43" />
                  </Routes>
                </div>
                <Footer data-id="element-45" />
                <CookieBanner data-id="element-46" />
              </div>
            </CartProvider>
          </WishlistProvider>
        </UserProvider>
      </NotificationsProvider>
    </BrowserRouter>;
}